import { PAGE_VIEW_TYPES, PAGE_KEYS, PAGE_PATH } from "./types";

// Web payment
import { WEB_PAYMENT_PAGES } from "./onboarding/payment";

// Allianz pages
import { ALLIANZ_PAGES } from "./onboarding/allianz";

// Path pages
import { CHOOSE_PERSON_PAGES } from "./onboarding/choose-path";

// Mobile pages
import { MOBILE_PAYMENT_PAGES } from "./mobile/payment";

// Myself pages
import { PREMIUM_WELCOME_PAGES } from "./onboarding/premium/welcome";
import { PREMIUM_ANXIETY_PAGES } from "./onboarding/premium/anxiety";
import { PREMIUM_PROGRAM_PAGES } from "./onboarding/premium/program";

// Parent pages
import { PARENT_WELCOME_PAGES } from "./onboarding/parent/welcome";
import { PARENT_PROGRAM_PAGES } from "./onboarding/parent/program";

// Therapist client pages
import { THERAPIST_CLIENT_PAYMENT_PAGES } from "./therapist-client/payment";

// Partner paywall pages
import { PARTNER_PAYMENT_PAGES } from "./partner/payment";
import { PARTNER_WELCOME_PAGES } from "./partner/welcome";

// Referrer pages
import { REFERRER_WELCOME_PAGES } from "./onboarding/premium/referrer_welcome";
import { REFERRER_PAYMENT_PAGES } from "./onboarding/premium/referrer_payment";

/**
 * Combine maps of available pages across app.
 * Data layer for onboarding SPA
 */
function createStack(appType) {
  switch (appType) {
    // Mobile stack
    case PAGE_VIEW_TYPES.mobilePayment:
      return {
        ...MOBILE_PAYMENT_PAGES,
      };
    // Therapist client stack
    case PAGE_VIEW_TYPES.therapistClient:
      return {
        ...THERAPIST_CLIENT_PAYMENT_PAGES,
        ...WEB_PAYMENT_PAGES,
        ...ALLIANZ_PAGES,
      };
    // Partner onboarding stack
    case PAGE_VIEW_TYPES.partnerOnboarding:
      return {
        ...webStack,
        ...WEB_PAYMENT_PAGES,
        ...ALLIANZ_PAGES,
        ...REFERRER_WELCOME_PAGES,
        ...REFERRER_PAYMENT_PAGES,
        ...PARTNER_WELCOME_PAGES,
      };
    // Partner checkout stack
    case PAGE_VIEW_TYPES.partnerCheckout:
      return {
        ...PARTNER_PAYMENT_PAGES,
      };
    // Referral stack
    case PAGE_VIEW_TYPES.referral:
      return {
        ...webStack,
        ...REFERRER_WELCOME_PAGES,
        ...PARTNER_WELCOME_PAGES,
      };
    // Web stack
    case PAGE_VIEW_TYPES.web:
    default:
      return webStack;
  }
}

const webStack = {
  // Choose path           --> Should be it's on stack
  ...CHOOSE_PERSON_PAGES,

  // Myself specific pages --> Should be it's on stack
  ...PREMIUM_WELCOME_PAGES,
  ...PREMIUM_ANXIETY_PAGES,
  ...PREMIUM_PROGRAM_PAGES,

  // Parent specific pages --> Should be it's on stack
  ...PARENT_WELCOME_PAGES,
  ...PARENT_PROGRAM_PAGES,

  // Applies to both parent and myself paths
  ...WEB_PAYMENT_PAGES,
  ...ALLIANZ_PAGES,
};

const PAGES = (appType) => {
  return { ...createStack(appType) };
};

export { PAGES, PAGE_VIEW_TYPES, PAGE_KEYS, PAGE_PATH };
